import { tableTheme } from "../../dashboard/reports/components/table/utils/theme";
import MUIDataTable, { MUIDataTableProps } from "mui-datatables";
import { defaultOptions } from "../../dashboard/reports/components/table/utils/options";
import { Theme, ThemeProvider } from "@mui/material";

type Props = {
  components?: MUIDataTableProps["components"];
  cols: MUIDataTableProps["columns"];
  tableData: MUIDataTableProps["data"];
  title?: MUIDataTableProps["title"];
  options?: MUIDataTableProps["options"];
  theme?: Theme;
};

export const ThemedTable = ({ components, cols, tableData, title, options, theme }: Props) => {
  return (
    <ThemeProvider theme={theme || tableTheme}>
      <div data-testid="mui-datatable">
        {/* @ts-ignore */}
        <MUIDataTable title={title || ""} data={tableData} columns={cols} options={options || defaultOptions} components={components} />
      </div>
    </ThemeProvider>
);
};
